import * as React from 'react';
import styled, { css } from 'styled-components';
import { IDateRangePickerFooterProps } from './date-range-picker-footer';
import { SecondaryButton, PrimaryButton } from '../../button';

const commonStyles = css`
    height: 35px;
    margin-right: 16px;
`;

const ResetButton = styled(SecondaryButton).attrs(() => ({
    className: String('ap-dateRangePicker-resetButton')
}))`
    ${commonStyles};
`;

const ApplyButton = styled(PrimaryButton).attrs(() => ({
    className: String('ap-dateRangePicker-applyButton')
}))`
    ${commonStyles};
`;

interface IDateRangePickerActionButtonProps extends Pick<IDateRangePickerFooterProps, 'onResetClick' | 'onApplyClick' | 'className' | 'applyButtonLabel' | 'resetButtonLabel'> {
    isApplyButtonDisabled: boolean;
}

const DateRangePickerActionButtonsWrapperBase = React.memo((props: IDateRangePickerActionButtonProps) => {
    const { onResetClick, onApplyClick, isApplyButtonDisabled, className, resetButtonLabel, applyButtonLabel } = props;

    return (
        <div className={className}>
            <ResetButton label={resetButtonLabel} onClick={onResetClick} />
            <ApplyButton label={applyButtonLabel} onClick={onApplyClick} disabled={isApplyButtonDisabled} />
        </div>
    );
});

DateRangePickerActionButtonsWrapperBase.displayName = 'DateRangePickerActionButtonsWrapper';

export const DateRangePickerActionButtonsWrapper = styled(DateRangePickerActionButtonsWrapperBase).attrs(() => ({
    className: String('ap-dateRangePicker-actionButtons-wrapper')
}))`
    display: inline-block;
    box-sizing: border-box;
    text-align: right;
    width: 50%;
`;
